import React from 'react';
import { useAppSelector} from "../DAL/store";
import Imgix from "react-imgix";
import {
    clickProfileReportAnIssue, clickProfileSite,
    getEpochFromDate,
    getSocialIconByDomainName
} from '../../common/services/logic-provider';
import VerifiedIcon from "../../../../ui/svg/common/verified";
import { AVATAR_PATH } from '../../common/constants';


const CreatorDetails = () => {

    const PublicCreatorProfileData = useAppSelector((store) => store.PublicCreatorProfileData);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    return (
        <div className="w-full">
            <div className="flex mt-8">
                <div className="">
                        <div className="w-40 h-40 mr-8 xl:mr-12">
                            {PublicCreatorProfileData.profile.imgExt.length > 0 ?
                                <Imgix
                                    src= {imgCdnDomain + "/" + creatorsPath +
                                          PublicCreatorProfileData.profile.prfUserGUID + "." +
                                          PublicCreatorProfileData.profile.imgExt + "?epoch=" + getEpochFromDate(PublicCreatorProfileData.profile.itemModifiedWhen)}
                                    sizes={"auto"}
                                    width={400}
                                    height={400}
                                    imgixParams={{mask:"ellipse" }}
                                    htmlAttributes={{
                                        alt: `${PublicCreatorProfileData.profile.handle} profile image`,
                                        loading: 'lazy',
                                    }}

                                />
                                :
                                <Imgix
                                    src= {imgCdnDomain + AVATAR_PATH}
                                    sizes={"auto"}
                                    width={400}
                                    height={400}
                                    imgixParams={{ fit: "facearea",facepad:"1.9",mask:"ellipse" }}
                                    htmlAttributes={{
                                        alt: `${PublicCreatorProfileData.profile.handle} profile image`,
                                        loading: 'lazy',
                                    }}
                                />
                            }
                        </div>

                </div>
                <div className="flex-1 h-max">
                    <div className="w-full flex items-center h-min relative">
                        <div className="flex-1">
                            <div className="w-full text-3xl font-bold flex justify-between items-center">
                                <div className="flex items-center">
                                    <h1>{PublicCreatorProfileData.profile.publicName}</h1>
                                    {PublicCreatorProfileData.profile.isVerified &&
                                        <div className="ml-2">
                                            <VerifiedIcon width="20px" />
                                        </div>
                                    }
                                </div>
                                <span className="text-base font-normal">
                                    <button type="button" className="text-black underline cursor-pointer"  onClick={() => clickProfileReportAnIssue(PublicCreatorProfileData.profile)} >Report an issue</button>
                                </span>

                            </div>
                        </div>

                    </div>
                    <div className="w-full py-1">@{PublicCreatorProfileData.profile.handle}
                        {PublicCreatorProfileData.profile.isUserOwner ?
                            <span>
                                <span className="px-2">|</span>
                                <a href={"/account/edit-my-creator-profile"}>Edit Profile</a>
                            </span>
                            :<></>}
                    </div>

                    <div className="lg:w-3/4 grow pt-2 text-sm">
                        {PublicCreatorProfileData.profile.bio}
                    </div>
                    <div className="flex items-center justify-start mt-4">

                        {PublicCreatorProfileData.sites.length > 0 &&
                            <div className="mr-2 font-bold">Follow</div>
                        }
                        {PublicCreatorProfileData.sites.map((site,index) => {
                            return  <button type="button" key={index} className="mx-2 cursor-pointer" onClick={() => clickProfileSite(site)}
                                       >{getSocialIconByDomainName(site.domainName,"15px")}
                                    </button>
                        })}
                    </div>

                </div>

            </div>
        </div>

    )
};

export default CreatorDetails;